import { render, staticRenderFns } from "./DateFormItem.vue?vue&type=template&id=6974ab95&"
import script from "./DateFormItem.vue?vue&type=script&lang=js&"
export * from "./DateFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports